import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SelectModule } from '@rappi/ui/select';
import { RangeDatepickerModule } from '@rappi/ui/range-datepicker';

import { ReportAutomationRoutingModule } from './report-automation-routing.module';
import { ReportAutomationComponent } from './report-automation/report-automation.component';
import { NewReportModalComponent } from './report-automation/components/new-report-modal/new-report-modal.component';

@NgModule({
  declarations: [
    ReportAutomationComponent,
    NewReportModalComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    SelectModule,
    RangeDatepickerModule,
    ReportAutomationRoutingModule
  ]
})
export class ReportAutomationModule {}
